<template>
    <settings-wrapper title="Organization settings" section="Users">
        <v-card class="overflow-hidden">
            <v-tabs ref="tabs" color="primary" v-model="tab">
                <v-tab v-for="tab in tabs" :key="tab.tabName">
                    <v-icon left small>{{ tab.icon }}</v-icon>
                    {{ tab.tabName }}
                </v-tab>
            </v-tabs>
        </v-card>

        <v-tabs-items class="mt-7" v-model="tab">
            <v-tab-item v-for="tab in tabs" :key="tab.tabName">
                <component :is="tab.component"></component>
            </v-tab-item>
        </v-tabs-items>
    </settings-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import { enumsData } from '@/mixins/enums'
import SettingsWrapper from '@/components/SettingsWrapper.vue'
const OrganizationUsers = () => import('../components/OrganizationUsers')
const OrganizationUserInvitations = () => import('../components/OrganizationUserInvitations')
export default {
    name: 'OrganizationUserManagement',
    components: { OrganizationUsers, OrganizationUserInvitations, SettingsWrapper },
    mixins: [enumsData],
    data() {
        return {
            tab: null,
            dataForInstanceToInviteTo: null
        }
    },
    computed: {
        ...mapGetters('orgStore', ['isOrgManager']),
        tabs() {
            if (this.isOrgManager) {
                return [
                    { tabName: 'Users', icon: 'mdi-account-group-outline', component: 'OrganizationUsers' },
                    { tabName: 'Invitations', icon: 'mdi-email-outline', component: 'OrganizationUserInvitations' }
                ]
            } else {
                return [{ tabName: 'Users', icon: 'mdi-account-group-outline', component: 'OrganizationUsers' }]
            }
        }
    },
    mounted() {
        this.$store.dispatch('orgStore/fetchOrgUsers', this.$route.params.oid)
        this.$store.dispatch('orgStore/fetchOrgInvitations', this.$route.params.oid)
    },
    watch: {
        tab() {
            setTimeout(() => {
                this.$refs.tabs.onResize()
            }, 300)
        }
    }
}
</script>
